import { Typography, withStyles } from '@material-ui/core';
import React from 'react';

const styles = (theme) => ({
  footer: {
    backgroundColor: '#1F2018',
    color: theme.palette.primary.contrastText,
    minHeight: 64,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

function Footer({ classes }) {
  return (
    <footer className={classes.footer}>
      <Typography variant="subtitle1" align="center" color="inherit" component="p">
        &copy; omniX labs. All rights reserved {new Date().getFullYear()}.
      </Typography>
    </footer>
  );
}

export default withStyles(styles)(React.memo(Footer));
